var render, staticRenderFns
import script from "./ScreenOrientationAlert.vue?vue&type=script&lang=jsx&"
export * from "./ScreenOrientationAlert.vue?vue&type=script&lang=jsx&"
import style0 from "./ScreenOrientationAlert.vue?vue&type=style&index=0&id=63a2e579&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports